import Canvas from './scalable-canvas'

/*
 * FullwidthCanvas is an extension of the scalable canvas, meant to take up
 * the full width of its parent container. The height
 */
var FullwidthCanvas = Canvas.extend({

  className: 'scalable-canvas fullwidth-canvas',

  sizeStyles: function () {
    const width = 'auto'
    // Remove the previously set width so we can calculate the actual width of the parent
    this.el.style.width = width

    const dim = this.dimensions()
    const scale = dim.actualParentWidth / dim.contentWidth
    return {
      width,
      height: `${dim.contentHeight * scale}`,
      'transform': `scale(${scale})`,
      'padding-bottom': `${this.padding}px`,
      'padding-top': `${this.padding}px`,
      'padding-left': `${this.padding}px`,
      'padding-right': `${this.padding}px`,
    }

  }

})

export default FullwidthCanvas
